import {axiosInstance} from "@/plugins/axios";
import {User} from "@/modules/user/types";

export async function getUser(id: string) {
  const response = await axiosInstance.get(`users/${id}`);
  return response.data;
}

export async function getUsers() {
  const response = await axiosInstance.get(`users`);
  return response.data;
}

export async function saveUser(user: User) {
  await axiosInstance.post(`users`, user);
}

export async function updateUser(user: User) {
  await axiosInstance.put(`users/${user.id_auth}`, user);
}

export async function deleteUser(id: string) {
  await axiosInstance.delete(`users/${id}`);
}
